import React, { useEffect, useState } from "react";

/**
 * Réplica do components/pdf-preview.tsx do Omnyve.CPU.UI.
 * Busca o PDF como blob (mesma origem, via proxy) e renderiza num iframe.
 */
const PdfPreview = ({ fileUrl }) => {
  const [pdfSrc, setPdfSrc] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    let objectUrl = "";

    const loadPdf = async () => {
      try {
        setIsLoading(true);
        setHasError(false);
        setPdfSrc("");

        const response = await fetch(fileUrl, {
          credentials: "include",
          signal: controller.signal,
          cache: "no-store",
        });

        if (!response.ok) {
          throw new Error(`Failed to load PDF: ${response.status}`);
        }

        const blob = await response.blob();
        objectUrl = URL.createObjectURL(blob);
        setPdfSrc(objectUrl);
      } catch (e) {
        if (!controller.signal.aborted) {
          setHasError(true);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    loadPdf();

    return () => {
      controller.abort();
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [fileUrl]);

  if (isLoading) {
    return <div className="pdf-preview-status">Carregando PDF...</div>;
  }

  if (hasError || !pdfSrc) {
    return (
      <div className="pdf-preview-status">
        <a href={fileUrl} target="_blank" rel="noreferrer">
          Abrir PDF
        </a>
      </div>
    );
  }

  return (
    <iframe
      title="pdf-preview"
      src={pdfSrc}
      width="100%"
      height="100%"
      frameBorder="0"
    />
  );
};

export default PdfPreview;
